import { useContext } from 'react'
import AppContext from 'context/AppContext'

function useElementNames() {
  const { sorElementMapping } = useContext(AppContext)
  return sorElementMapping
}
export default useElementNames
